import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'parts': [],
  'sfx': '',
};

export const stockDownload = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PARTS_BY_ORDER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PARTS_BY_ORDER]: (state, action) => ({
      ...state,
      'loading': false,
      'parts': action.response.data,
      'sfx': action.response.sfx,
    }),
    [ActionTypes.FETCHED_PARTS_BY_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'parts': [],
      'sfx': '',
    }),
  })(state, action);
};
